module.exports = __webpack_public_path__ + "assets/delete_success_male.svg?v=3049cffa91edff0f24044bbac9f62800";